module.exports = __webpack_public_path__ + "media/images/emoticons/sweat02-d763a3e1b0da8aa366d997d23ff271d7.gif";